module.exports = __webpack_public_path__ + "img/tomato_half.e21d4237.svg";